<template>
  <div class="password-forgot">
    <div class="password-forgot__container">
      <form class="password-forgot__form" action="#" method="post">
        <span class="password-forgot__caption">
          Восстановление доступа
        </span>
        <span class="password-forgot__error" v-show="hasError" v-html="error"></span>
        <div class="password-forgot__input-group">
          <input
              class="password-forgot__input"
              type="email"
              placeholder="E-mail"
              v-model="email"
              :class="{ 'password-forgot__input_error' : hasError}"
          >
        </div>
        <app-button class="password-forgot__button" button-style="button_action" is-submit @click.prevent="forgot">
          Восстановить доступ
        </app-button>
        <router-link class="password-forgot__link" :to="{ name: 'Login' }">
          Войти
        </router-link>
      </form>
      <footer class="password-forgot__footer">
        &#169; 2022-{{ new Date().getFullYear() }} ГК “Триумф”
      </footer>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton'
import { forgot } from '@/api/auth'
import { isError } from '@/utils/request'

export default {
  name: 'PasswordForgot',
  components: {
    AppButton
  },
  data() {
    return {
      email: '',
      error: '',
      hasError: false
    }
  },
  methods: {
    async forgot() {
      this.error = ''
      this.hasError = false

      const response = await forgot(this.email)

      if (isError(response.status)) {
        if (response.status === 422) {
          for (const [key, value] of Object.entries(response.data.errors.validation)) {
            for (const error of value) {
              this.error += `${error}<br>`
            }
          }
        } else {
          this.error = response.data.meta.message
        }

        this.hasError = true

        return
      }

      this.email = ''

      this.$notify({
        type: 'success',
        text: response.data.meta.message
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.password-forgot {
  min-height: 100vh;
  padding: 50px 20px;
}

.password-forgot__form {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #eaedf4;
  border-radius: $border-radius;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.03);
}

.password-forgot__caption {
  display: inline-block;
  width: 100%;
  margin-bottom: 22px;
  font-size: 14px;
  text-align: center;
}

.password-forgot__error {
  display: inline-block;
  width: 100%;
  margin-bottom: 10px;
  font-size: 13px;
  color: #d31a1a;
}

.password-forgot__input {
  width: 100%;
  height: 50px;
  margin-bottom: 15px;
  padding-left: 20px;
  font-size: 13px;
  background-color: #fcfdfe;
  border: 1px solid #eaedf4;
  border-radius: $border-radius;

  &:last-child {
    margin-bottom: 20px;
  }

  &:focus {
    outline: none;
  }

  &_error {
    border: 1px solid #D31A1A;
  }
}

.password-forgot__button {
  width: 100%;
  margin-bottom: 20px;
}

.password-forgot__link {
  display: inline-block;
  width: 100%;
  font-size: 12px;
  text-align: center;
  color: #555;
}

.password-forgot__footer {
  display: inline-block;
  width: 100%;
  font-size: 12px;
  text-align: center;
  color: #555;
}

@media screen and (min-width: 576px) {
  .password-forgot {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .password-forgot__container {
    width: 440px;
  }

  .password-forgot__form {
    margin-bottom: 23px;
    padding: 54px 60px;
  }

  .password-forgot__caption {
    font-size: 17px;
  }

  .password-forgot__input {
    margin-bottom: 30px;
    font-size: 14px;

    &:last-child {
      margin-bottom: 40px;
    }
  }

  .password-forgot__button {
    width: 100%;
    margin-bottom: 23px;
  }

  .password-forgot__link {
    font-size: 16px;
  }

  .password-forgot__footer {
    font-size: 16px;
  }
}
</style>